module.exports = __webpack_public_path__ + "static/githl-mtn-icon-99263b169204e5fedf73f6fdab2cfdae.png";